import { FormFieldsType, SendEmailTypes } from '@/types/SendEmailTypes';
import axiosInstance from '@/helpers/axiosInstance';

export default async (payload: FormFieldsType) => {
  const { data } = await axiosInstance.post<SendEmailTypes>('/sendmail', payload);

  return data;
};
